module.exports = __webpack_public_path__ + "img/remixicon.symbol.1601b68a.svg";